import type {
  Configuration,
  CreateThreatHuntingScanRequestRequest,
  ListThreatHuntingResultsRequest,
  ListThreatHuntingScanRequestsRequest,
  UpdateThreatHuntingScanRequestRequest,
} from '@repo/api-gw-sdk';
import { ThreatHuntingApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/threat-hunting';

export const threatHunting = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const threatHuntingApi = new ThreatHuntingApi(config);

  return {
    scanRequests: {
      useList: (
        body?: ListThreatHuntingScanRequestsRequest,
        pageToken?: string,
        pageSize?: number
      ) =>
        httpClient.execute(
          threatHuntingApi.listThreatHuntingScanRequests.bind(threatHuntingApi),
          baseUrl,
          'scan-requests',
          currentProjectId,
          pageToken,
          pageSize,
          body
        ),
      create: (body: CreateThreatHuntingScanRequestRequest) =>
        threatHuntingApi.createThreatHuntingScanRequest(currentProjectId, body),
      update: (
        requestId: string,
        body: UpdateThreatHuntingScanRequestRequest
      ) =>
        threatHuntingApi.updateThreatHuntingScanRequest(
          currentProjectId,
          requestId,
          body
        ),
      remove: (requestId: string) =>
        threatHuntingApi.deleteThreatHuntingScanRequest(
          currentProjectId,
          requestId
        ),
    },
    results: {
      useList: (
        body?: ListThreatHuntingResultsRequest,
        pageToken?: string,
        pageSize?: number
      ) =>
        httpClient.execute(
          threatHuntingApi.listThreatHuntingResults.bind(threatHuntingApi),
          baseUrl,
          'results',
          currentProjectId,
          pageToken,
          pageSize,
          body
        ),
      list: (
        body: ListThreatHuntingResultsRequest,
        pageToken?: string,
        pageSize?: number
      ) =>
        threatHuntingApi.listThreatHuntingResults(
          currentProjectId,
          pageToken,
          pageSize,
          body
        ),
    },
  };
};
